import * as R from "remeda";
import { BsonDocument, LineBotProviderData } from "@/API";
import { Button, Group, Modal, TextInput } from "@mantine/core";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { PropsWithChildren, useEffect, useState } from "react";

export function LineBotProviderDataEditForm(props: { value: BsonDocument, onChange: (value: BsonDocument) => void }) {
    const form = useForm<LineBotProviderData>({
        initialValues: props.value,
        validate: {
            channelId: (value) => (!value ? 'ChannelId 不得為空' : null),
            channelSecret: (value) => (!value ? 'ChannelSecret 不得為空' : null),
            channelAccessToken: (value) => (!value ? 'ChannelAccessToken 不得為空' : null),
        },
        onValuesChange: values => props.onChange(values)
    });

    useEffect(() => {
        if (!R.isDeepEqual(form.values, props.value)) {
            form.setValues(props.value);
        }
    }, [props.value]);

    return <>
        <form>
            <TextInput
                withAsterisk
                label="channelId"
                {...form.getInputProps('channelId')}
            />
            <TextInput
                withAsterisk
                label="channelSecret"
                {...form.getInputProps('channelSecret')}
            />
            <TextInput
                withAsterisk
                label="channelAccessToken"
                {...form.getInputProps('channelAccessToken')}
            />
        </form>
    </>

}

export function LineBotProviderDataEditButton(props: { initValue?: BsonDocument, onChange?: (value: BsonDocument) => void } & PropsWithChildren) {
    const [opened, { open, close }] = useDisclosure(false);
    const [data, setData] = useState<BsonDocument>(props.initValue ?? {})

    useEffect(() => {
        if (opened && props.initValue) {
            setData(props.initValue)
        }
    }, [opened])

    return <>
        <div onClick={open}>
            {props.children}
        </div>
        <Modal opened={opened} onClose={close} title="LINE連接設定">
            <LineBotProviderDataEditForm value={data} onChange={v => setData(v)} />
            <Group justify="flex-end" mt="md">
                <Button onClick={() => {
                    props.onChange?.(data)
                    close()
                }}>確認</Button>
            </Group>
        </Modal>
    </>
}